import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`

export async function getTenantDetail(contractId) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/tenant-detail`)
  if (!response.ok) throw new Error('Error al obtener el detalle del inquilino')
  return response.json()
}

export async function searchContracts(parkId, query) {
  const response = await fetch(
    `${API_BASE}/parks/${parkId}/contracts/search?q=${encodeURIComponent(query)}`
  )
  if (!response.ok) throw new Error('Error al buscar contratos')
  return response.json()
}

export async function getContractCounts(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/contracts/counts`)
  if (!response.ok) throw new Error('Error al obtener los contadores de contratos')
  const data = await response.json()
  return {
    todos: data.todos,
    activos: data.activos,
    porVencer: data.por_vencer,
    negociacion: data.negociacion,
    vencidos: data.vencidos,
    historicos: data.historicos,
  }
}

export async function getContractAlerts(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/contracts/alerts`)
  if (!response.ok) throw new Error('Error al obtener las alertas de contratos')
  return response.json()
}

export async function dismissAllContractAlerts(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/contracts/alerts/dismiss-all`, { method: 'POST' })
  if (!response.ok) throw new Error('Error al descartar las alertas')
  return response.json()
}

export async function applyEscalation(contractId, newRent) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/apply-escalation`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ newRent }),
  })
  if (!response.ok) throw new Error('Error al aplicar la escalación')
  return response.json()
}

export async function getContractsList(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/contracts/list`)
  if (!response.ok) throw new Error('Error al obtener la lista de contratos')
  return response.json()
}

export async function getContractDetail(contractId) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/detail`)
  if (!response.ok) throw new Error('Error al obtener el detalle del contrato')
  return response.json()
}

export async function registerPayment(contractId, payload) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/payments`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al registrar el pago')
  return response.json()
}

export async function addContractNote(contractId, text, author) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/notes`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ text, author }),
  })
  if (!response.ok) throw new Error('Error al agregar la nota')
  return response.json()
}

export async function addContact(contractId, payload) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/contacts`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al agregar el contacto')
  return response.json()
}

export async function uploadContractDocument(contractId, file, type) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)

  const response = await fetch(`${API_BASE}/contracts/${contractId}/documents/upload`, {
    method: 'POST', body: formData,
  })
  if (!response.ok) throw new Error('Error al subir el documento')
  return response.json()
}

export function getDocumentUrl(filePath) {
  return `${API_BASE.replace('/api', '')}/uploads/${filePath}`
}

export async function deleteContractDocument(documentId) {
  const response = await fetch(`${API_BASE}/contracts/documents/${documentId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar el documento')
  return response.json()
}

export async function updateContractStatus(contractId, status) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/status`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status }),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Error al actualizar el estatus')
  }
  return response.json()
}

export async function updateConditions(contractId, payload) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/conditions`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al actualizar las condiciones')
  return response.json()
}

export async function updatePortalAccess(contractId, enabled) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/portal-access`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ enabled }),
  })
  if (!response.ok) throw new Error('Error al actualizar el acceso al portal')
  return response.json()
}

export async function getPortalAccount(contractId) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/portal-account`)
  if (!response.ok) throw new Error('Error al consultar el acceso al portal')
  return response.json()
}

export async function invitePortalTenant(contractId, payload) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/portal-account/invitation`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Error al generar la invitación')
  }
  return response.json()
}

export async function setPortalAccountSuspended(contractId, suspended) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/portal-account/status`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ suspended }),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Error al actualizar la cuenta')
  }
  return response.json()
}

export async function updateContractProcess(contractId, payload) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/process`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al actualizar el proceso')
  return response.json()
}

export async function updateContact(contactId, payload) {
  const response = await fetch(`${API_BASE}/contracts/contacts/${contactId}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al actualizar el contacto')
  return response.json()
}

export async function deleteContact(contactId) {
  const response = await fetch(`${API_BASE}/contracts/contacts/${contactId}`, { method: 'DELETE' })
  if (!response.ok) throw new Error('Error al eliminar el contacto')
  return response.json()
}

export async function confirmRenewal(contractId, payload) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/confirm-renewal`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) throw new Error('Error al confirmar la renovación')
  return response.json()
}

export function getContractPdfUrl(contractId, type) {
  return `${API_BASE}/contracts/${contractId}/pdf?type=${type}`
}

// Descarga el PDF como archivo. Si el servidor responde con un aviso (p. ej. «sin saldo pendiente»), se lanza con su mensaje.
export async function downloadContractPdf(contractId, type) {
  const response = await fetch(getContractPdfUrl(contractId, type))
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.message || data.error || 'No se pudo generar el PDF')
  }
  const blob = await response.blob()
  const name = /filename="([^"]+)"/.exec(response.headers.get('Content-Disposition') || '')?.[1] || `${type}.pdf`
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 10000)
}

export async function getAvailablePlots(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/plots/available`)
  if (!response.ok) throw new Error('Error al obtener las naves disponibles')
  return response.json()
}

export async function createContract(payload) {
  const response = await fetch(`${API_BASE}/contracts`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Error al crear el contrato')
  }
  return response.json()
}
export async function getContractHistory(contractId) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/history`)
  if (!response.ok) throw new Error('Error al obtener el historial anterior a Parkos')
  return response.json()
}

export async function setHistoryMonthPaid(contractId, invoiceId, amountPaid) {
  const response = await fetch(`${API_BASE}/contracts/${contractId}/history/${invoiceId}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ amountPaid }),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Error al corregir el historial')
  }
  return response.json()
}